import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amount-report',
  templateUrl: './amount-report.component.html',
  styleUrls: ['./amount-report.component.css']
})
export class AmountReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
